export default __webpack_public_path__ + "static/media/army_112.ac9e35e7.jpg";